export default __webpack_public_path__ + "static/media/LYD01568.2acfcac0.jpg";